export default "__VITE_ASSET__DsKoC_0b__"